export default [
  {
    orderID: 1,
    ponumber: "AEAN2001",
    clientname: "Davis GAA Club",
    orderDate: "1/9/2020",
    orderReference: "REF123",
    makeuplocation:"",
    productionlocation:"",
    artwork:"",
    garmentname:"Personalised Gaelic Jersey"
  },
  
   {
    orderID: 3,
    ponumber: "DDHS1265",
    clientname: "Armagh Harps GAA",
    orderDate: "30/8/2020",
    orderReference: "DAVID-1",
    makeuplocation: "",
    productionlocation:"",
    artwork:"",
    garmentname:"Personalised Gaelic Jersey"
  }
  ,
  
   {
    orderID: 3,
    ponumber: "DDHS1264",
    clientname: "Armagh Harps GAA",
    orderDate: "30/8/2020",
    orderReference: "DAVID-2",
    makeuplocation: "",
    productionlocation:"",
    artwork:"",
    garmentname:"Soccer Shorts"
  },
  {
   orderID: 4,
   ponumber: "DDHS1263",
   clientname: "Belfast KC Shop",
   orderDate: "30/8/2020",
   orderReference: "DAVID-3",
   makeuplocation: "",
   productionlocation:"",
   artwork:"",
   garmentname:"Personalised Soccer Jersey"
 },
 {
  orderID: 5,
  ponumber: "EAPE3454",
  clientname: "AFC Warner",
  orderDate: "27/8/2020",
  orderReference: "warner1",
  makeuplocation: "",
  productionlocation:"",
  artwork:"",
  garmentname:"Personalised Rugby Jersey"
},
{
 orderID: 6,
 ponumber: "EAPE3453",
 clientname: "AFC Warner",
 orderDate: "27/8/2020",
 orderReference: "warner1",
 makeuplocation: "",
 productionlocation:"",
 artwork:"",
 garmentname:"Rugby Shorts"
}
]